export const SERVICE_SUCCESS = 'SERVICE_SUCCESS'
export const SERVICE_FAILURE = 'SERVICE_FAILURE'

export const serviceData = (service) =>{
    return (dispatch, getState) => {
        dispatch({ type: SERVICE_SUCCESS,service });
    }
}
